import { createGlobalStyle } from 'styled-components';
import { reset } from 'styled-reset';

export const GlobalStyle = createGlobalStyle`
    ${reset}
    body {
      margin: 0;
      padding: 0;
      font-family: 'Pretendard', sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      box-sizing: border-box; /* 엘리먼트의 box-sizing 값을 border-box로 설정 */
      background-color: '#121212';
      color: black;
      overflow-x: hidden;
      overflow-y: scroll;
       // 스크롤바 제거
      -ms-overflow-style: none;
    }
    // 스크롤바 제거
    ::-webkit-scrollbar {
      display: none;
    }
    #root {
      min-height: 100%;
    }
    html {
      height: 100%;
      scroll-behavior: smooth;
    }
    a {
      color: inherit;
      text-decoration: none;
    }
    * {
      box-sizing: inherit; /* 모든 엘리먼트의 box-sizing 값을 border-box로 설정 */
    }
    code {
      font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
        monospace;
    }
    button {
      background: inherit;
      border: none;
      box-shadow: none;
      border-radius: 0;
      padding: 0;
      overflow: visible;
      cursor: pointer;
    }
    button:focus {
      outline: none;
    }

    &::-webkit-scrollbar {
      width: 0px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(211, 211, 211, 0.5);
      border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
      background-color: none;
    }
`;
